import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { enablePlaceholder } from '@ckeditor/ckeditor5-engine/src/view/placeholder';
import { toWidget, toWidgetEditable } from '@ckeditor/ckeditor5-widget/src/utils';
import Widget from '@ckeditor/ckeditor5-widget/src/widget';

import AddQuestionCommand from './addquestioncommand';

export default class AddQuestionEditing extends Plugin {
  static get requires() {
    return [Widget];
  }

  init() {
    console.log('AddQuestionEditing was initialized', this.editor);
    this._defineSchema();
    this._defineConverters();
    this.editor.commands.add('insertSimpleBox', new AddQuestionCommand(this.editor));
  }

  _defineSchema() {
    const schema = this.editor.model.schema;

    schema.register('simpleBox', {
      // Behaves like a self-contained object (e.g. an image).
      isObject: true,

      // Allow in places where other blocks are allowed (e.g. directly in the root).
      allowWhere: '$block'
    });

    schema.register('simpleBoxTitle', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'simpleBox',

      // Allow content which is allowed in blocks (i.e. text with attributes).
      allowContentOf: '$block'
    });

    schema.register('simpleBoxDescription', {
      // Cannot be split or left by the caret.
      isLimit: true,

      allowIn: 'simpleBox',

      // Allow content which is allowed in the root (e.g. paragraphs).
      allowContentOf: '$root',
      allowAttributes: ['placeholdertext']
    });

    schema.addChildCheck((context, childDefinition) => {
      if (context.endsWith('simpleBoxDescription') && childDefinition.name == 'simpleBox') {
        return false;
      }
    });
  }

  // _defineConverters() {
  //   const conversion = this.editor.conversion;

  //   conversion.elementToElement({
  //     model: 'simpleBox',
  //     view: {
  //       name: 'section',
  //       classes: 'simple-box'
  //     }
  //   });

  //   conversion.elementToElement({
  //     model: 'simpleBoxTitle',
  //     view: {
  //       name: 'h2',
  //       classes: 'simple-box-title',
  //       // attributes: {
  //       //   'data-placeholder': "Add your custom question here"
  //       // }
  //     }
  //   });

  //   conversion.elementToElement({
  //     model: 'simpleBoxDescription',
  //     view: {
  //       name: 'div',
  //       classes: 'simple-box-description'
  //     }
  //   });
  // }

  _defineConverters() {
    const conversion = this.editor.conversion;
    const view = this.editor.editing.view;
    const t = this.editor.t;

    // <simpleBox> converters
    conversion.for('upcast').elementToElement({
      model: 'simpleBox',
      view: {
        name: 'section',
        classes: 'simple-box'
      }
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'simpleBox',
      view: {
        name: 'section',
        classes: 'simple-box'
      }
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'simpleBox',
      view: (modelElement, { writer: viewWriter }) => {
        const section = viewWriter.createContainerElement('section', { class: 'simple-box' });

        return toWidget(section, viewWriter, { label: 'simple box widget' });
      }
    });

    // <simpleBoxTitle> converters
    conversion.for('upcast').elementToElement({
      model: 'simpleBoxTitle',
      view: {
        name: 'h2',
        classes: 'simple-box-title'
      }
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'simpleBoxTitle',
      view: {
        name: 'h2',
        classes: 'simple-box-title'
      }
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'simpleBoxTitle',
      view: (modelElement, { writer: viewWriter }) => {
        // Note: You use a more specialized createEditableElement() method here.
        const h2 = viewWriter.createEditableElement('h2', { class: 'simple-box-title' });

        viewWriter.setCustomProperty('placeholder', true, h2);

        enablePlaceholder({
          view,
          element: h2,
          text: t('Add your question here...'),
          keepOnFocus: true
        });

        return toWidgetEditable(h2, viewWriter);
      }
    });

    // <simpleBoxDescription> converters
    conversion.for('upcast').elementToElement({
      view: {
        name: 'div',
        classes: 'simple-box-description'
      },
      model: (viewElement, { writer: modelWriter }) => {
        console.log("upcast===>elementToElement===>", viewElement, viewElement.getAttribute('placeholdertext'), modelWriter);
        return modelWriter.createElement('simpleBoxDescription', { placeholdertext: viewElement.getAttribute('placeholdertext') });
      }
    });
    conversion.for('dataDowncast').elementToElement({
      model: 'simpleBoxDescription',
      view: {
        name: 'div',
        classes: 'simple-box-description'
      }
    });
    conversion.for('editingDowncast').elementToElement({
      model: 'simpleBoxDescription',
      view: (modelElement, { writer: viewWriter }) => {
        const placeholder = modelElement.getAttribute('placeholdertext');

        // Note: You use a more specialized createEditableElement() method here.
        const div = viewWriter.createEditableElement('div', { class: 'simple-box-description' });

        viewWriter.setCustomProperty('placeholder', true, div);

        enablePlaceholder({
          view,
          element: div,
          text: placeholder ? t(placeholder) : 'Add your answer here...',
          keepOnFocus: true,
          isDirectHost: false
        });

        return toWidgetEditable(div, viewWriter);
      }
    });
  }
}